import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import {
  addToWishlist as addToWishlistService,
  addWishlistToCart,
  getWishlist as getWishlistService,
  removeItemFromWishlist as removeWishlistService,
} from '@/services'
import { useCommonStore } from './common'
import { TypeOptions } from 'react-toastify'
import { useCartStore } from './cart'

interface TWishlistState extends IWishlist {}

type TWishlistAction = {
  getWishlist: (data?: { page?: number; pageSize?: number }) => void
  addToWishlist: (
    wishlistItem: Omit<IWishlistFetching<IWishlistItemsDefault>, 'wishlistId'>
  ) => Promise<IResponse<any>>
  removeItemFromWishlist: (data: string) => Promise<IResponse<any>> //product's id in wishlist
  addItemToCart: (id: string) => void //product's id in wishlist
  clearWishlist: () => void
}

type TWishlistStore = TWishlistState & TWishlistAction

const initialWishlistStore: TWishlistState = {
  wishlistId: '',
  wishlistItems: {
    items: [],
  },
}

export const useWishlistStore = create<TWishlistStore>()(
  devtools(
    persist(
      (set, get) => ({
        wishlistId: initialWishlistStore.wishlistId,
        wishlistItems: initialWishlistStore.wishlistItems,
        getWishlist: async (data) => {
          const page = data?.page
          const pageSize = data?.pageSize
          const res = await getWishlistService({ page, pageSize })
          if (res?.status == 'error') {
            useCommonStore.getState().setNoti(res?.message, res?.status ?? 'error')
            return
          }
          set(() => ({ wishlistId: res?.id, wishlistItems: res?.items_v2 }))
        },
        addToWishlist: async (data) => {
          const response = await addToWishlistService({
            wishlistId: get().wishlistId,
            wishlistItems: data?.wishlistItems,
          })
          console.log('🚀 ~ response:', response)
          if (response?.status == 'error') {
            return { status: response?.status ?? 'error', message: response?.message }
          } else {
            await get().getWishlist()
            return { status: response?.status ?? 'success', message: response?.message }
          }
        },
        removeItemFromWishlist: async (data) => {
          const response = await removeWishlistService({
            wishlistId: get().wishlistId,
            wishlistItems: [data],
          })
          if (response?.status == 'error') {
            return { status: response?.status ?? 'error', message: response?.message }
          } else {
            await get().getWishlist()
            return { status: response?.status ?? 'success', message: response?.message }
          }
        },
        addItemToCart: async (data) => {
          const response = await addWishlistToCart({
            wishlistId: get().wishlistId,
            wishlistItems: [data],
          })
          if (response?.status == 'error') {
            useCommonStore.getState().setNoti(response?.message, response?.status ?? 'error')
          } else {
            useCommonStore
              .getState()
              .setNoti(response?.message, (response?.status as TypeOptions | undefined) ?? 'success')
            get().getWishlist()
            useCartStore.getState().refetchCart()
          }
        },
        clearWishlist: () => {
          set(() => ({ ...initialWishlistStore }))
        },
      }),
      {
        name: 'wishlist-storage',
      }
    )
  )
)

// store/wishlist.ts - Simplified
// import { create } from 'zustand'
// import { devtools, persist } from 'zustand/middleware'

// interface TWishlistUIState {
//   // Chỉ lưu UI state, không lưu data từ API
//   selectedItems: string[]
//   filters: {
//     sortBy: string
//     category: string
//   }
//   viewMode: 'grid' | 'list'
// }

// type TWishlistUIActions = {
//   setSelectedItems: (items: string[]) => void
//   toggleItemSelection: (itemId: string) => void
//   setFilters: (filters: Partial<TWishlistUIState['filters']>) => void
//   setViewMode: (mode: 'grid' | 'list') => void
//   clearSelection: () => void
// }

// type TWishlistStore = TWishlistUIState & TWishlistUIActions

// const initialUIState: TWishlistUIState = {
//   selectedItems: [],
//   filters: {
//     sortBy: 'newest',
//     category: 'all',
//   },
//   viewMode: 'grid',
// }

// export const useWishlistUIStore = create<TWishlistStore>()(
//   devtools(
//     persist(
//       (set, get) => ({
//         ...initialUIState,

//         setSelectedItems: (items) => set({ selectedItems: items }),

//         toggleItemSelection: (itemId) => {
//           const { selectedItems } = get()
//           const newSelection = selectedItems.includes(itemId)
//             ? selectedItems.filter((id) => id !== itemId)
//             : [...selectedItems, itemId]
//           set({ selectedItems: newSelection })
//         },

//         setFilters: (filters) =>
//           set((state) => ({
//             filters: { ...state.filters, ...filters },
//           })),

//         setViewMode: (mode) => set({ viewMode: mode }),

//         clearSelection: () => set({ selectedItems: [] }),
//       }),
//       {
//         name: 'wishlist-ui-storage',
//         // Chỉ persist UI state, không persist API data
//         partialize: (state) => ({
//           filters: state.filters,
//           viewMode: state.viewMode,
//         }),
//       }
//     )
//   )
// )
